import React from 'react'

export interface IconProps {
    width?: string | number;
    height?: string | number;
    className?: string;
}

export default function SupportHelpIcon({
    width = 100,
    height = 100,
    className = '',
}: IconProps) {
    return (
        <svg
            version="1.0"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 192.000000 150.000000"
            preserveAspectRatio="xMidYMid meet"
            className={`cursor-pointer group-hover:stroke-white transition duration-200 ${className}`}
        >
            <g transform="translate(0.000000,150.000000) scale(0.100000,-0.100000)" fill="#fff" stroke="none">
                <path d="M466 1179 c-55 -43 -56 -51 -56 -403 l0 -325 -22 -3 c-21 -3 -23 -9 -26 -65 -3 -73 14 -115 58 -138 44 -23 1066 -23 1110 0 44 23 61 65 58 138 -3 56 -5 62 -25 65 l-23 3 0 320 c0 347 -3 366 -55 407 -28 22 -30 22 -510 22 -474 0 -483 0 -509 -21z m1009 -44 l25 -24 0 -331 0 -330 -190 0 c-172 0 -191 -2 -207 -19 -31 -32 -60 -41 -128 -41 -68 0 -97 9 -128 41 -16 17 -35 19 -207 19 l-190 0 0 330 0 331 25 24 24 25 476 0 476 0 24 -25z m-644 -742 c23 -27 75 -43 144 -43 69 0 121 16 144 43 12 15 40 17 222 17 l209 0 0 -47 c0 -34 -6 -53 -22 -70 l-21 -23 -531 0 -530 0 -23 22 c-18 17 -23 32 -23 70 l0 48 209 0 c182 0 210 -2 222 -17z" />
                <path d="M495 1107 c-3 -6 -4 -149 -3 -317 l3 -305 483 -3 482 -2 -2 317 -3 318 -478 3 c-379 2 -479 0 -482 -11z m925 -307 l0 -280 -445 0 -445 0 0 280 0 280 445 0 445 0 0 -280z" />
                <path d="M904 1035 c-59 -26 -111 -100 -113 -161 -1 -13 -9 -24 -21 -27 -18 -5 -20 -14 -20 -97 l0 -91 63 3 62 3 0 85 c0 79 -2 86 -22 95 -45 19 -15 105 49 145 89 54 218 -10 218 -108 0 -21 -6 -31 -20 -35 -18 -5 -20 -14 -20 -92 0 -78 2 -87 20 -92 11 -3 20 -14 20 -24 0 -15 -7 -19 -34 -19 -18 0 -39 7 -46 15 -15 18 -51 20 -68 3 -7 -7 -12 -24 -12 -38 0 -14 5 -31 12 -38 17 -17 67 -15 74 3 4 10 19 15 43 15 44 0 61 14 61 51 0 21 5 28 23 31 21 3 22 8 25 91 3 82 1 89 -18 94 -14 4 -20 14 -20 34 0 118 -142 204 -256 154z m-64 -280 c0 -52 -1 -55 -25 -55 -24 0 -25 3 -25 55 0 52 1 55 25 55 24 0 25 -3 25 -55z m320 0 c0 -48 -2 -55 -20 -55 -18 0 -20 7 -20 55 0 48 2 55 20 55 18 0 20 -7 20 -55z m-140 -153 c0 -13 -12 -22 -22 -16 -10 6 -1 24 13 24 5 0 9 -4 9 -8z" />
            </g>
        </svg>
    )
}